export class TextEntry {
  slug: string;
  value: string;

  constructor(text?: TextEntry) {
    this.slug = text?.slug ?? null;
    this.value = text?.value ?? null;
  }
}
